<!--
 * @Description: 首页
 * @Author: xiawenlong
 * @Date: 2021-04-20 10:47:44
 * @LastEditors: xiawenlong
 * @LastEditTime: 2026-06-25 08:50:08
-->
<template>
  <div class="dashboard">
    <!-- <InfoCard /> -->
    <EnterCard :menu-list="menuList" :super-admin-detail="superAdminDetail" />
    <SalesDynamicsCard :college-news="collegeNews" />
    <SalesDataCard :data-trend-list="dataTrendList" @change="onSalesDataChange" />
    <CourseSalesCard :sale-rank-list="salerankList" />
    <DistributeDataCard :distribute-list="distributeList" />
    <OtherSalesCard :other-sales-list="otherSalesList" />
  </div>
</template>
<script>
import { salesDynamic, salesData, salesCountRank } from '@/api/dashboard'
import to from 'await-to'
import {
  // InfoCard,
  EnterCard,
} from './components'
// import * as type from '@/store/action-types'
import { getUserMenu, getSearchSuperAdmin } from '@/api/college'
import * as echarts from 'echarts/core'
import { GridComponent } from 'echarts/components'
import { BarChart } from 'echarts/charts'
import { CanvasRenderer } from 'echarts/renderers'
import { mapGetters } from 'vuex'
import SalesDynamicsCard from './components/SalesDynamicsCard'
import SalesDataCard from './components/SalesDataCard'
import CourseSalesCard from './components/CourseSalseRankCard'
import DistributeDataCard from './components/DistributeDataCard'
import OtherSalesCard from './components/OtherSalesCard'
echarts.use([GridComponent, BarChart, CanvasRenderer])

export default {
  components: {
    // InfoCard,
    EnterCard,
    SalesDynamicsCard,
    SalesDataCard,
    CourseSalesCard,
    DistributeDataCard,
    OtherSalesCard,
  },
  data() {
    return {
      collegeNews: [],
      pager: {
        total: 0,
        size: 4,
        current: 1,
      },
      superAdminDetail: {},
      menuList: [],
      clientCode: '0a983d86-2527-5512-01a9-783cd0e1',
      dataTrendList: {}, //销量趋势
      salerankList: [], //课程销量排名
      distributeList: {}, //分销业绩
      otherSalesList: {}, //其他营收
      // salesActivePeriod: '',
      // salesStartTime: '',
      // salesEndTime: '',
    }
  },
  computed: {
    ...mapGetters(['userInfo']),
  },
  // watch: {
  //   salesActivePeriod(newVal) {
  //     console.log('activePeriod changed:', newVal)
  //   },
  //   salesStartTime(newVal) {
  //     console.log('startTime changed:', newVal)
  //   },
  //   salesEndTime(newVal) {
  //     console.log('endTime changed:', newVal)
  //   },
  // },
  inject: ['orgReady'],
  created() {
    this.getCollegeNewsData()
    // this.getCollegeInfo()
    this.getSearchSuperAdminData()
    this.getMenuData()
    this.handleGetSalesRank()
  },
  mounted() {},
  methods: {
    onSalesDataChange({ activePeriod, startTime, endTime }) {
      // this.salesActivePeriod = activePeriod
      // this.salesStartTime = startTime
      // this.salesEndTime = endTime
      this.handleGetSalesData(activePeriod, startTime, endTime)
    },
    async getCollegeNewsData() {
      const [res, err] = await to(salesDynamic({}))
      if (err) return this.$message({ type: 'error', message: err.msg })
      this.collegeNews = res.data
    },
    // async getCollegeInfo() {
    //   const [res, err] = await to(getSearchCollegeNews({}))
    //   if (err) return
    //   this.$store.commit(`user/${type.SET_COLLEGE_INFO}`, res.data)
    // },
    async getSearchSuperAdminData() {
      const [res, err] = await to(getSearchSuperAdmin())
      if (err) return this.$message({ type: 'error', message: err.msg })
      this.superAdminDetail = res.data
    },
    async getMenuData() {
      await this.orgReady.promise
      const [res, err] = await to(getUserMenu({ clientCode: this.clientCode }))
      if (err) return
      // this.$message.warning(err.msg)
      this.menuList = res.data
    },
    async handleGetSalesData(statisticsType, startTime, endTime) {
      const [res, err] = await to(
        salesData({ statisticsType: statisticsType, startTime: startTime, endTime: endTime }),
      )
      if (err) return this.$message({ type: 'error', message: err.msg })
      this.dataTrendList = res.data.saleTrend
      this.distributeList = res.data.distributorPerformance
      this.otherSalesList = res.data.otherRevenue
    },
    async handleGetSalesRank() {
      const [res, err] = await to(salesCountRank({}))
      if (err) return this.$message({ type: 'error', message: err.msg })
      this.salerankList = res.data
    },
  },
}
</script>
<style lang="scss" scoped>
.dashboard {
  cursor: default;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  ::v-deep .card {
    background-color: #fff;
    margin-bottom: 20px;
    .header {
      position: relative;
      height: 54px;
      display: flex;
      align-items: center;
      padding: 0 20px;
      border-bottom: 1px solid #e2e2e2;
      .title {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 18px;
        font-weight: 500;
        color: #333333;
        &::before {
          content: '';
          position: absolute;
          left: 0;
          top: 12px;
          width: 4px;
          height: 32px;
          background: #ff7b33;
        }
        span {
          cursor: pointer;
          font-size: 14px;
          font-weight: 500;
          color: #ff7b33;
        }
      }
    }
  }
}
</style>
